import { render } from "./reportsTwo.vue?vue&type=template&id=c6519e34&scoped=true"
import script from "./reportsTwo.vue?vue&type=script&lang=js"
export * from "./reportsTwo.vue?vue&type=script&lang=js"

import "./reportsTwo.vue?vue&type=style&index=0&id=c6519e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6519e34"]])

export default __exports__